import type { Content } from '../../models';

import { TableTypes } from '../../config/constants';
import { table1ToTable2 } from '../charts23/table2';

export const validateContentVersion72 = (content: Content): boolean => {
  const { type, typeSpecific } = content;
  if (typeSpecific.version < 72) {
    if (TableTypes.includes(type) && typeSpecific.table && typeSpecific.fields) {
      typeSpecific.table2 = typeSpecific.table2 ?? table1ToTable2(typeSpecific.table, typeSpecific.fields);

      // set color type for Heatmaps
      if (typeSpecific?.style?.colors2) typeSpecific.style.colors2.type = 'gradient';
    }

    // typeSpecific.version = 72;
  }

  return true;
};
